var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"600px","scrollable":""},model:{value:(_vm.subtitlesPresetStore.managePresets),callback:function ($$v) {_vm.$set(_vm.subtitlesPresetStore, "managePresets", $$v)},expression:"subtitlesPresetStore.managePresets"}},[_c('SubtitlesPresetsCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }